import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { UserSettings } from '../../components/UserSettings';

export default function SettingsPage(): React.ReactElement {
  const { username } = useParams<{ username: string }>();

  if (!username) return <Navigate to="/" replace />;

  return <UserSettings username={username} />;
}
